import { render } from "./QuickSearch.vue?vue&type=template&id=332cf329"
import script from "./QuickSearch.vue?vue&type=script&lang=js"
export * from "./QuickSearch.vue?vue&type=script&lang=js"
script.render = render

export default script